import styled from 'styled-components';

import { Blurb } from 'components/Containers';
import { useTranslation } from 'context/translations';
import { simpleDate } from 'lib/date';
import { colors } from 'styles/theme/colors';
import { BodySmall, BodySmallBold, Label } from 'styles/typography';
import PencilIcon from 'svg/PencilIcon';

type ExpectedDischargeProps = {
  showEdit: boolean;
  date: string;
  setShowDeterminantsEdit: (showDeterminantsEdit: boolean) => void;
};

const ExpectedDischarge = ({ showEdit, date, setShowDeterminantsEdit }: ExpectedDischargeProps) => {
  const { translate } = useTranslation();

  return (
    <Blurb>
      <DischargeHeader>
        <Label>Projected {translate('Discharge')} Date</Label>
        <Spacer />
        {showEdit && (
          <ActionContainer data-cy='clickable' onClick={() => setShowDeterminantsEdit(true)}>
            <PencilIcon width={12} height={12} color={colors.blue100} />
            <BodySmall>Edit</BodySmall>
          </ActionContainer>
        )}
      </DischargeHeader>
      <DischargeDate>
        <BodySmallBold>{date ? simpleDate(date) : '—'}</BodySmallBold>
      </DischargeDate>
    </Blurb>
  );
};

const DischargeHeader = styled.div`
  display: flex;
  padding: 24px 24px 8px;
  align-items: center;
`;

const Spacer = styled.div`
  flex: 1;
`;

const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${colors.blue100};
  gap: 4px;
  font-size: 12px;
`;

const DischargeDate = styled.div`
  padding: 0 24px 24px;
`;

export default ExpectedDischarge;
